<template>
  <van-radio-group
    v-model="myValue"
    :style="{
      '--radio-button-height': height,
      '--radio-button-border-radius': borderRadius,
      '--radio-button-min-width': minWidth,
      '--radio-button-min-font-size': fontSize,
    }"
    class="radio-group-buttons"
    direction="horizontal"
    @change="valueChange"
  >
    <slot />
  </van-radio-group>
</template>

<script>
export default {
  name: 'WhButtonRadioGroup',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: [String, Number, Boolean],
      default: undefined
    },
    height: {
      type: String,
      default: '28px'
    },
    borderRadius: {
      type: String,
      default: '20px'
    },
    minWidth: {
      type: String,
      default: 'auto'
    },
    fontSize: {
      type: String,
      default: '14px'
    }
  },
  computed: {
    myValue: {
      get() {
        return this.value
      },
      set(val) {
        this.valueChange(val)
      }
    }
  },
  methods: {
    valueChange(val) {
      this.$emit('change', val)
    }
  }
}
</script>

<style lang='less' scoped>

.radio-group-buttons {
  /deep/ .van-radio {
    .van-radio__icon {
      display: none;
    }
    .van-radio__label {
      margin: 0;
      border-radius: var(--radio-button-border-radius);
      height: var(--radio-button-height);
      min-width: var(--radio-button-min-width);
      text-align: center;
      font-size: var(--radio-button-font-size);
      font-weight: 500;
      background: #fff;
      color: #505050;
      padding: 4px;
      border: 1px solid #ccc;
    }
    &[aria-checked="true"] {
      .van-radio__label {
        /*border-color: #25cca1;*/
      }
    }
  }
}
</style>
